import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconIntravenousTherapyComponent } from "./med-icon-intravenous-therapy.component";

@NgModule({
  declarations: [
    MedIconIntravenousTherapyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconIntravenousTherapyComponent,
  ],
})
export class MedIconIntravenousTherapyModule { }
